import {
  getCountries,
  getCountryCallingCode,
  CountryCode,
} from "libphonenumber-js";

export interface CountryOption {
  code: CountryCode;
  name: string;
  dial: string;
  callingCode: string;
}

export const DEFAULT_COUNTRY_CODE: CountryCode = "US";

const displayNames =
  typeof Intl !== "undefined" && "DisplayNames" in Intl
    ? new Intl.DisplayNames(["en"], { type: "region" })
    : null;

export const COUNTRIES: readonly CountryOption[] = getCountries()
  .map((code) => {
    const callingCode = getCountryCallingCode(code);
    return {
      code,
      name: displayNames?.of(code) ?? code,
      dial: `+${callingCode}`,
      callingCode,
    };
  })
  .sort((a, b) => a.name.localeCompare(b.name));

const countryByCode = new Map(
  COUNTRIES.map((country) => [country.code, country] as const)
);

function requireCountry(code: CountryCode): CountryOption {
  const country = countryByCode.get(code);
  if (!country) {
    throw new Error(`Country "${code}" is missing from the country list`);
  }
  return country;
}

const defaultCountry = requireCountry(DEFAULT_COUNTRY_CODE);

export function getCountryByCode(code: CountryCode): CountryOption {
  return countryByCode.get(code) ?? defaultCountry;
}
